<template>
    <div id="app">
        <router-view></router-view>
        <LoadingBox ref="LoadingBox"></LoadingBox>
        <ConfirmBox ref="ConfirmBox"></ConfirmBox>
        <ConnectWalletBox ref="ConnectWalletBox"></ConnectWalletBox>
    </div>
</template>
<script>
import bus from '@/assets/js/bus';
import ConfirmBox from '@/components/ConfirmBox';
import ConnectWalletBox from '@/components/ConnectWalletBox';
import LoadingBox from '@/components/LoadingBox';
export default {
    components:{
        ConnectWalletBox,LoadingBox,ConfirmBox
    },
    data() {
		return {
		};
	},
    created(){
        let _this = this;
        bus.$on('showLoadingBox',async() =>  {
            if(_this.$refs.LoadingBox){
                _this.$refs.LoadingBox.show();
            }
        });
        bus.$on('hideLoadingBox',async() =>  {
            if(_this.$refs.LoadingBox){
                _this.$refs.LoadingBox.close();
            }
        });

        bus.$on('showConfirmBox',async(msg) =>  {
            _this.$refs.ConfirmBox.show(msg.type,msg.token1,msg.token2);
        });
        bus.$on('hideConfirmBox',async() =>  {
            _this.$refs.ConfirmBox.close();
        });
        bus.$on('setConfirmBox',async(num) =>  {
            _this.$refs.ConfirmBox.setSetNum(num);
        });

        bus.$on('showConnectWalletBox',async(msg) =>  {
            if(_this.$refs.ConnectWalletBox){
                _this.$refs.ConnectWalletBox.show(msg);
            }
        });
        bus.$on('hideConnectWalletBox',async(msg) =>  {
            if(_this.$refs.ConnectWalletBox){
                _this.$refs.ConnectWalletBox.close();
            }
        });
        
        bus.$on('connectWallet',async(msg) =>  {
            this.connectWallet();
        });
    },
    mounted(){
    },
    methods:{
    }
}
</script>

<style lang='less'>
    // @import "./assets/css/common.less"; 
    // @import "./assets/css/theme-dark.less";
</style>

<style lang='css'>
    /* @import "./assets/css/main.css"; */
</style>